module.exports = __webpack_public_path__ + "fonts/Montserrat-Light.bcf14e71.ttf";